import EventEmitter from '@/utils/events.ts'

export type TLiftMonitoringEvent = {
  state: {
    live: boolean
    ts: number
  }
}

const liftMonitoringEventEmitter = new EventEmitter<TLiftMonitoringEvent>()
export default liftMonitoringEventEmitter
